<template>
    <ConfirmDialog></ConfirmDialog>
    <section class="categories-section pt-2 text-zinc-900 dark:text-zinc-100 min-h-screen">
        <div class="menu-row">
            <div v-if="categories.length > 0">
                <Menu class="categories-menu bg-white text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100 border border-zinc-200 dark:border-zinc-700 rounded shadow" :model="categories" />
            </div>
            <Button
                icon="pi pi-plus"
                class="add-category-btn"
                @click="showNewCategoryDialog = true"
                aria-label="Agregar nueva categoría"
                rounded
            />
        </div>
        <Dialog v-model:visible="showUpdateCategoryDialog" modal :header="`Actualizar categoría ${updateCategoryHeader}`" :style="{ width: '40rem' }"
            class="bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100">
            <div class="grid justify-center">
                <span class="p-text-secondary block mb-5">Actualiza o elimina la categoría.</span>
                <div class="form-row">
                    <label class="font-semibold w-6rem" for="category">Nombre</label>
                    <div class="input-group">
                        <InputText class="w-96 bg-zinc-100 text-zinc-900 border border-zinc-300 focus:border-indigo-400 focus:ring-indigo-400 dark:bg-zinc-800 dark:text-zinc-100 dark:border-zinc-700 dark:focus:border-indigo-600 dark:focus:ring-indigo-600 transition-colors" id="category" v-model="category.label" aria-describedby="category-help" />
                        <small id="category-help">Ingresa el nuevo nombre para la categoría.</small>
                        <div class="button-group">
                            <Button label="Guardar" icon="pi pi-check" class="accept-btn" @click="saveCategory" />
                            <Button label="Eliminar" icon="pi pi-trash" class="delete-btn" @click="killCategory" />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
        <Dialog v-model:visible="showNewCategoryDialog" modal header="Agregar nueva categoría" :style="{ width: '30rem' }"
            class="bg-white text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100">
            <div class="grid justify-center">
                <div class="form-row">
                    <label class="font-semibold w-6rem" for="new-category">Nombre</label>
                    <div class="input-group">
                        <InputText class="w-96 bg-zinc-100 text-zinc-900 border border-zinc-300 focus:border-indigo-400 focus:ring-indigo-400 dark:bg-zinc-800 dark:text-zinc-100 dark:border-zinc-700 dark:focus:border-indigo-600 dark:focus:ring-indigo-600 transition-colors" id="new-category" v-model="newCategoryLabel" aria-describedby="new-category-help" />
                        <small id="new-category-help">Ingresa el nombre para la nueva categoría.</small>
                        <div class="button-group">
                            <Button label="Guardar" icon="pi pi-check" class="accept-btn" @click="createCategory" />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    </section>
</template>

<script>
    import axiosInstance from '../axiosInstance';

    export default {
        data() {
            return {
                categories: [],
                category: {
                    label: "",
                    id: null
                },
                updateCategoryHeader: "",
                newCategoryLabel: "",
                showUpdateCategoryDialog: false,
                showNewCategoryDialog: false
            }
        },
        methods: {
            async fetchCategoriesList(){
                this.$emit("update-loading", true);
                let data = {};
                try {
                    const response = axiosInstance.post("/api/expense_categories_list", {
                        token: localStorage.getItem('token')
                    });

                    data = await response;
            
                } catch(error) {
                    console.error("fetchCategoriesList: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                }

                return data;
            },

            loadCategories(){
                this.fetchCategoriesList().then((response) => {
                    if(response.status === 200){
                        const items = response.data.items;
                        this.categories = items.map((el) => {
                            return {
                                label: el.name,
                                icon: "pi pi-folder",
                                command: () => {
                                    this.loadCategory(el.id);
                                    this.updateCategoryHeader = el.name;
                                }
                            }
                        });
                    } else {
                        console.warn("loadCategories: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                })
            },

            async fetchCategory(id){
                this.$emit("update-loading", true);
                let data = {};
                try {
                    const response = axiosInstance.post("/api/expense_category", {
                        token: localStorage.getItem('token'),
                        id
                    });

                    data = await response;
            
                } catch(error) {
                    console.error("fetchCategory: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                }

                return data;
            },

            loadCategory(id) {
                this.fetchCategory(id).then((response) => {
                    if(response.status === 200) {
                        const item = response.data;
                        this.category = {
                            label: item.name,
                            id: item.id,
                        };

                        this.showUpdateCategoryDialog = true;
                    } else {
                        console.warn("loadCategory: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                })
            },

            /**
             * Creates or updates a category.
             */
            async patchPostCategory() {
                this.$emit("update-loading", true);
                let data = {};
                try {
                    const response = axiosInstance.post("/api/expense_category_save", {
                        token: localStorage.getItem('token'),
                        id: this.category.id,
                        name: this.category.label
                    });

                    data = await response;
            
                } catch(error) {
                    console.error("patchPostCategory: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al guardar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                }

                return data;
            },

            /**
             * Saves the category.
             * If the category has an id, it will update it.
             * If the category does not have an id, it will create a new one.
             */
            saveCategory() {
                this.patchPostCategory().then((response) => {
                    if(response.status === 200) {
                        this.showUpdateCategoryDialog = false;
                        this.category = {label: "", id: null};
                        this.loadCategories();
                    } else {
                        console.warn("saveCategory: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                })
            },

            async deleteCategory() {
                this.$emit("update-loading", true);
                let data = {};
                try {
                    const response = axiosInstance.post("/api/expense_category_kill", {
                        token: localStorage.getItem('token'),
                        id: this.category.id,
                    });

                    data = await response;
            
                } catch(error) {
                    console.error("deleteCategory: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al eliminar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                }

                return data;
            },

            killCategory(){
                this.$confirm.require({
                    message: `${this.updateCategoryHeader} será eliminada. ¿Estás seguro?`,
                    header: 'Confirmación de eliminación',
                    icon: 'pi pi-info-circle',
                    rejectLabel: 'Cancelar',
                    acceptLabel: 'Eliminar',
                    rejectClass: 'p-button-secondary p-button-outlined',
                    acceptClass: 'p-button-danger',
                    accept: () => {
                        this.deleteCategory().then((response) => {
                            if(response.status === 200) {
                                this.showUpdateCategoryDialog = false;
                                this.loadCategories();
                            }
                        })
                    }
                });
            },

            createCategory() {
                this.category.id = 0;
                this.category.label = this.newCategoryLabel;
                this.patchPostCategory().then((response) => {
                    if(response.status === 200) {
                        this.showNewCategoryDialog = false;
                        this.category = {label: "", id: null};
                        this.newCategoryLabel = "";
                        this.loadCategories();
                    } else {
                        console.warn("createCategory: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                })
            }
        },

        mounted() {
            this.loadCategories();
        }
    }
</script>

<style scoped>
    ::v-deep(.categories-menu) {
        width: 500px !important;
    }

    ::v-deep(.form-row) {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
    }

    ::v-deep(.form-row label) {
        min-height: 40px;
        display: flex;
        align-items: center;
    }

    ::v-deep(.input-group) {
        display: flex;
        flex-direction: column;
    }

    ::v-deep(.input-group small) {
        margin-top: 0.25rem;
        color: #6c757d;
    }

    ::v-deep(.button-group) {
        display: flex;
        gap: 1rem;
        margin-top: 1rem;
    }

    ::v-deep(.categories-section) {
        width: 100%;
    }

    ::v-deep(.menu-row) {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        gap: 1rem;
        margin-bottom: 2rem;
    }

    Button.add-category-btn {
        @apply self-start bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 transition-colors shadow-sm font-semibold px-3 py-2 rounded-full;
    }

    Button.accept-btn {
        @apply bg-green-100 text-green-900 border border-green-300 hover:bg-green-200 dark:bg-green-900 dark:text-green-100 dark:border-green-700 dark:hover:bg-green-800 transition-colors mr-2;
    }

    Button.delete-btn {
        @apply bg-red-100 text-red-900 border border-red-300 hover:bg-red-200 dark:bg-red-900 dark:text-red-100 dark:border-red-700 dark:hover:bg-red-800 transition-colors;
    }
</style>

<style>
/* Add category button - light mode */
html:not(.dark) Button.add-category-btn {
    background-color: #0f1338 !important;
    border-color: #0f1338 !important;
    color: white !important;
}

html:not(.dark) Button.add-category-btn:hover:not(:disabled) {
    background-color: #1a1f4d !important;
    border-color: #1a1f4d !important;
}

/* Add category button - dark mode */
html.dark Button.add-category-btn {
    background-color: #D9D9D9 !important;
    border-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

html.dark Button.add-category-btn:hover:not(:disabled) {
    background-color: #c4c4c4 !important;
    border-color: #c4c4c4 !important;
}

/* InputText hover and focus styles - light mode only */
html:not(.dark) .p-inputtext:not(.p-disabled):hover {
    border-color: #0f1338 !important;
}

html:not(.dark) .p-inputtext.p-focus,
html:not(.dark) .p-inputtext:focus {
    border-color: #0f1338 !important;
    box-shadow: 0 0 0 0.1rem rgba(15, 19, 56, 0.8) !important;
    outline: none !important;
}

/* Accept button - light mode */
html:not(.dark) Button.accept-btn:hover:not(:disabled) {
    border-color: #0f1338 !important;
    color: #0f1338 !important;
}

html:not(.dark) Button.accept-btn:focus,
html:not(.dark) Button.accept-btn.p-focus {
    border-color: #0f1338 !important;
    color: #0f1338 !important;
    box-shadow: 0 0 0 0.1rem rgba(15, 19, 56, 0.8) !important;
}

/* Delete button - light mode */
html:not(.dark) Button.delete-btn:hover:not(:disabled) {
    border-color: #0f1338 !important;
    color: #0f1338 !important;
}

html:not(.dark) Button.delete-btn:focus,
html:not(.dark) Button.delete-btn.p-focus {
    border-color: #0f1338 !important;
    color: #0f1338 !important;
    box-shadow: 0 0 0 0.1rem rgba(15, 19, 56, 0.8) !important;
}
</style>